import { harborService } from "../../jwt/_services/xailing/harborService";
import {
    setItems,
    setTableInfo,
    removeItem ,
    addItem
} from "./filterActions";
import {
    changeLoadingState,
    setDataToEdit,
    setEnabledForm,
} from "./genericActions";

export const searchHarbors = (page, currentIndex, sizePerPage, _dataFilters) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    harborService.search(currentIndex, sizePerPage, _dataFilters)
        .then(result => {
            if (!result)
                return

            const tableInfo = {
                page,
                sizePerPage,
                currentIndex,
                totalSize: result?.total
            }

            dispatch(setItems(result.data))
            dispatch(setTableInfo(tableInfo))
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const saveHarbor = data => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    return harborService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setDataToEdit(result) )
            dispatch( setEnabledForm(false) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const updateHarbor = (id, data) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    return harborService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setDataToEdit(result) )
            dispatch( setEnabledForm(false) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const deleteHarbor = (id, fbDb) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    harborService.deleteItem(id, fbDb)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}